<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="sm"
      spinner-variant="primary"
    >
      <b-card class="walk-card">
        <h4 class="heading">{{ $t("TrackingLogs") }}</h4>
        <div class="export-table">
          <b-form-checkbox
            id="tooltip-target-1"
            v-model="value"
            size="lg"
            name="cell_width"
            @change="logAction()"
            switch
          >
          </b-form-checkbox>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            {{ $t("TrackingLogs") }}
          </b-tooltip>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import $ from "jquery";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      value: true,
      log_track_id: "",
      sec: 2,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },
  created() {
    this.getTrackingLogs();
  },

  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    getTrackingLogs() {
      this.success = "";
      this.error = "";
      this.show = true;
      var company_id = this.$store.getters.currentUser.id;
      this.$store
        .dispatch("GetTrackingLogs", company_id)
        .then((res) => {
          //alert(res.data.data.track_log);
          this.value = res.data.data.track_log == 0 ? false : true;
          this.log_track_id = res.data.data.id;
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : TrackingLog.vue | Function : getTrackingLogs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          return false;
        });
    },

    /**
     * open popup
     */
    logAction() {
      this.success = "";
      this.error = "";
      this.show = true;
      var data = {
        track_log: this.value,
        log_track_id: this.log_track_id,
      };
      this.$store
        .dispatch("UpdateTrackLogs", data)
        .then((res) => {
          this.show = false;
          this.$store.getters.currentUser.track_log = this.value ? 1 : 0;
          Cookies.set("currentUser", this.$store.getters.currentUser);
          this.success = this.$t("StatusUpdated");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : TrackingLog.vue | Function : logAction() | Error :",
            error
          );
          this.show = false;
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style  scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.v-select {
  min-width: 180px;
}

.vs-con-table .vs-con-tbody {
  width: 100%;
  overflow: visible;
}

/* .top-alert {
  position: absolute;
  top: 0px;
  left: 50%;
  max-width: 350px;
  transform: translate(-50%, 10px);
  z-index: 99999;
  border-radius: 10px;
} */
</style>